var map = {
	"./d2-admin-text.svg": "ae5c",
	"./d2-admin.svg": "bb12",
	"./d2-thumb-down-solid-24.svg": "7205",
	"./d2-thumb-up-solid-24.svg": "2735",
	"./d2-tubiaoshangshengqushi.svg": "6dd3",
	"./d2-tubiaoxiajiangqushi.svg": "6835"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec399";